/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';

const iconStyle = { margin: 0, lineHeight: 1, height: '1em' };

// Deliberately reassuring about the running workspace, since a deprecated type keeps working:
// the catalogue upgrade flow leaves retired types approved so existing workspaces are unaffected,
// it only hides them from new workspace creation.
const DEPRECATED_TOOLTIP =
  'Heads up: This workspace is running an older configuration we no longer support. ' +
  'Nothing will break immediately, but it cannot be renewed after the expiry date, ' +
  'so it is recommended to move your work to a new workspace when you get a chance.';

/**
 * Marks a workspace whose env type has been retired.
 *
 * The label reads "Deprecated" rather than naming the type, because the type name itself is already
 * shown, with its markers stripped, in the Software card.
 */
function DeprecatedBadge() {
  return (
    <Popup
      trigger={
        // No title attribute here: it renders the browser's own tooltip on top of the Popup.
        <span className="workspace-deprecated-badge">
          <Icon name="history" style={iconStyle} />
          Deprecated
        </span>
      }
      content={DEPRECATED_TOOLTIP}
      size="small"
      position="top center"
      inverted
    />
  );
}

export default DeprecatedBadge;
export { DEPRECATED_TOOLTIP };
